<template>
	<div class="main-view">
		<div style="margin-bottom: 10px;
					display: flex;
					flex-direction: row;
					align-items: center;">
			<!-- <span style="color: #FF8826;">1</span>-->
			<div style="font-size: 14px;
						width: 6px;
						height: 15px;
						background-color: #409eff;
						margin-right: 5px;
						border-radius: 4px;"></div> 
			<span style="margin-left: 0px;">{{ cardTitle }}（共{{  questionArr.length}}题）</span>
		</div>
		<div class="quetion-item" v-for="item,index in questionArr" :key="index" :id="item.id">
			<div class="title-topic">
				
					<div class="label">
					{{item.text}}【{{ SUB_DRILL_TYPE[item.subType].label }}】
				</div>
				<img style="width: 50%;" mode="aspectFit" alt="" :src="item.imageUrl" v-if="item.imageUrl != null"/>
			</div>
			<div class="question-view" v-if="item.subType==102">
		
				<el-checkbox :label="`${option.id}.${option.text}`" class="el-checkbox" v-for="option,opIndex in item.optionList" :key="opIndex" >
					<el-image :src="option.imageUrl" class="option-img" v-if="option.imageUrl != null"></el-image>
				</el-checkbox>
			</div>
			<div class="question-view" v-if="item.subType==101 || item.subType==103">
				<el-radio-group v-model="checkList[index]">
					<el-radio :label="`${option.id}.${option.text}`"  class="el-radio" v-for="option,opIndex in item.optionList" :key="opIndex">
						<el-image :src="option.imageUrl" class="option-img" v-if="option.imageUrl != null"></el-image>
					</el-radio>
				</el-radio-group>
			</div>
			<div v-if="showAnswerFlagD" class="correctAnswer-view">正确答案：{{ item.correctAnswer.join('，') }}</div>
		</div>
		
		<!-- <div class="quetion-item">
			<div class="title-topic">
				2 . 以下选项选什么
				<a id="question2"></a>
				<image style="width: 100%;" mode="aspectFit" alt=""/>
			</div>
			<div class="question-view">
				<el-radio-group v-model="radio">
					<el-radio :label="3"  class="el-radio">
						<el-image :src="require('@/assets/defualt_img.png')" class="option-img"></el-image>
					</el-radio>
					<el-radio :label="6"  class="el-radio">备选项</el-radio>
					<el-radio :label="9"  class="el-radio">备选项</el-radio>
				</el-radio-group>
			</div>
		</div> -->
	</div>
</template>

<script>
import { SUB_DRILL_TYPE } from "@/utils/constant.js";
import ChoiceQuestionDrillApi from '@/api/src/drill/api/ChoiceQuestionDrillApi'
const choiceQuestionDrillApi = new ChoiceQuestionDrillApi()

export default {
	props:['showAnswerFlag','questionData','cardTitle'],
	data(){
		return{
			section:null,
			checkList: [],
			radio: 3,
			showAnswerFlagD:this.showAnswerFlag,
			questionDataArr:this.questionData,
			questionArr:[],
			SUB_DRILL_TYPE: SUB_DRILL_TYPE,
			cardTitleV:null
		}
	},
	mounted () {
		this.loadData()
	},
	watch:{
		showAnswerFlag(val){
			console.log("监听到变化")
			this.showAnswerFlagD = val
			this.$forceUpdate()
			//如果showAnswerFlagD为true，则清空this.checkList  如果shiwAnswerFlagD为false，则清空this.checkList
			// if(val){
			// 	this.checkList = ["复选框 A","复选框 C"]
			// }else{
			// 	this.checkList = []
			// }
		},
		// questionData(val){
		// 	console.log("监听到变化")
		// 	console.log(val)
		// 	this.section = val
		// }
	},
	methods:{
		getTempArr(){
			return []
		},
		radioChange(index,value){

		},
		async loadData(){
			let drillIds = this.questionDataArr.map(item => {return item.drillId})
			var body = {
				sessionTime: 0,
				idList: drillIds
			}
			var resp = await choiceQuestionDrillApi.getDrillList(body)
			console.log('----loadData---')
			console.log(resp)
			this.questionArr = resp
			this.checkList = Array.from({ length: this.questionArr.length }, () => []);
		},
		getCorrectAnswer(item,option){
			console.log("getCorrectAnswer")
			var value = false
			if(this.showAnswerFlagD == true){
				value = option.correctAnswer
			}else{
				value = false
			}
			console.log(value)
			return this.showAnswerFlagD
		}
	}
}
</script>

<style lang="less" scoped>
	.main-view{
		margin: 10px;
		border-radius: 10px; /* 圆角半径10px */
		box-shadow: 0 0 10px rgba(132, 132, 132, 0.3); /* 添加阴影效果 */
		padding: 20px; /* 内边距 */
		width: 87%;
	}

	.quetion-item{
		display: flex;
		flex-direction: column;
		.title-topic{
			font-size: 18px;
			margin-left: 10px;
			display: flex;
			flex-direction: column;
			.label{

			}
		}
		.question-view{
			margin-top: 10px;
			margin-bottom: 20px;
			margin-left: 20px;
		}
	}

	.el-checkbox {
		display: flex; 
		padding-top: 10px;
		flex-basis: 100%; 
		align-items: center;
	}
	.option-img{
		width: 100px;
		height: 100px;
	}
	.el-radio{
		display: flex; 
		padding-top: 10px;
		flex-basis: 100%; 
		align-items: center;
		/deep/ .el-radio__label{

			font-size:14px !important;
			
		}
	}
	.correctAnswer-view{
	    margin: 20px;
		margin-top: 10px;
		color: green;
	}
</style>